module.exports = __webpack_public_path__ + "img/completedasmnt.73f2b44b.svg";